import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "list-reports-page",
  class: "page list-reports-page"
}
const _hoisted_2 = {
  ref: "filterPanel",
  class: "mt-10 page-filters-wrapper mb-6"
}
const _hoisted_3 = ["threshold"]
const _hoisted_4 = { class: "filter-menu" }
const _hoisted_5 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_PerformanceAttribution = _resolveComponent("PerformanceAttribution")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          threshold: _ctx.filterPanelPosition,
          class: _normalizeClass(["navbar page-filters-panel pos-relative justify-space-between", _ctx.scrolledAll ? 'vue-fixed-header--isFixed' : ''])
        }, [
          _createVNode(_component_v_layout, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                align: "end",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "d-flex",
                    cols: "12",
                    sm: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "3",
                            "align-self": "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_label, null, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode("Provider", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_autocomplete, {
                                "model-value": _ctx.currentFilters.provider,
                                items: _ctx.providers,
                                "item-title": "name",
                                "item-value": "id",
                                label: "Provider",
                                variant: "solo",
                                disabled: _ctx.fetchingChartData,
                                "hide-details": "",
                                density: "compact",
                                class: "mt-2 filter-btn-active",
                                "single-line": "",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                        (e) => {
                          _ctx.onProviderChange(e);
                        }
                      )
                              }, null, 8, ["model-value", "items", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    class: "d-flex justify-end my-2",
                    cols: "12",
                    sm: "3"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isSuperUser)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "filter-btn elevation-6 mt-0 mx-2",
                            ripple: false,
                            "data-testid": "ShowData",
                            variant: "text",
                            disabled: _ctx.fetchingChartData,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetails = true))
                          }, {
                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("div", { class: "mx-2" }, "Show Details", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      false
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "filter-btn back-btn elevation-6 mt-0 mr-2",
                            ripple: false,
                            variant: "text",
                            to: "/reports"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                  _createTextVNode("fas fa-arrow-left", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        class: "filter-btn elevation-6 mt-0 mx-2",
                        ripple: false,
                        "data-testid": "ExportReportBtn",
                        variant: "text",
                        disabled: _ctx.fetchingChartData,
                        loading: _ctx.processingReport,
                        onClick: _ctx.exportReport
                      }, {
                        default: _withCtx(() => [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mx-2" }, "Export", -1)),
                          _createVNode(_component_v_icon, { small: "" }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createTextVNode("fas fa-file-pdf", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading", "onClick"]),
                      _createVNode(_component_v_menu, {
                        "content-class": "filter-content",
                        modelValue: _ctx.filterIsVisible,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterIsVisible) = $event)),
                        "nudge-bottom": 15,
                        "close-on-content-click": false,
                        left: "",
                        offset: "20",
                        transition: "slide-y-transition"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            class: "filter-btn elevation-6 mt-0",
                            "data-testid": "FilterBtn",
                            color: "primary",
                            variant: "text",
                            outlined: "",
                            disabled: _ctx.fetchingChartData
                          }, props, { small: "" }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                  _createTextVNode("fas fa-filter", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.priceTrackChart ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateFilter('priceTrackChart')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createTextVNode("Price Track Comparison", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.irrSingle ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateFilter('irrSingle')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                        _createTextVNode("IRR Single Contribution", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.irrSingleHeatmap ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateFilter('irrSingleHeatmap')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                        _createTextVNode("IRR Single Heatmap", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.irrSingle3d ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateFilter('irrSingle3d')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                        _createTextVNode("IRR Single Contribution 3D", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.irrRegular ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateFilter('irrRegular')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                        _createTextVNode("IRR Regular Contribution", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.irrRegularHeatmap ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateFilter('irrRegularHeatmap')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                        _createTextVNode("IRR Regular Heatmap", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.irrRegular3d ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateFilter('irrRegular3d')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                        _createTextVNode("IRR Regular Contribution 3D", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.effectOfContrib ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateFilter('effectOfContrib')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                        _createTextVNode("Effect Of Contributions", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.actualIrrChart ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateFilter('actualIrrChart')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                        _createTextVNode("Portfolio IRR", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass([_ctx.currentFilters.regressionChart ? 'v-list-item--active' : '', "filter-list"]),
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateFilter('regressionChart')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                        _createTextVNode("Regression Chart", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 10, _hoisted_3)
      ], 512),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showDetails,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showDetails) = $event)),
        width: "50%"
      }, {
        default: _withCtx(() => [
          (_ctx.performanceAttributionData)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { style: {"color":"#0000008a"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Beta : " + _toDisplayString(_ctx.performanceAttributionData.Beta) + " ", 1),
                      _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" Alpha : " + _toDisplayString(_ctx.performanceAttributionData.SAAValue), 1),
                      _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" Final Price Tracker : " + _toDisplayString(_ctx.performanceAttributionData.finalPriceTracker), 1),
                      _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" Correct Prices, Wrong Prices, Wrong Members Included, Members Contributed To Price Calculation: " + _toDisplayString(_ctx.performanceAttributionData.correctPrices) + " Complete Price Tracker(Run again if not available) : " + _toDisplayString(_ctx.performanceAttributionData.priceTracker), 1),
                      _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                  _createTextVNode(" LOADING... ", -1)
                ]))]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        (!_ctx.fetchingReports && this.providers && this.providers.length > 0 && _ctx.performanceAttributionData)
          ? (_openBlock(), _createBlock(_component_PerformanceAttribution, {
              key: 0,
              reportData: _ctx.performanceAttributionData,
              providerId: _ctx.currentFilters.provider,
              currentFilters: _ctx.currentFilters
            }, null, 8, ["reportData", "providerId", "currentFilters"]))
          : (_ctx.fetchingReports)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "grey"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "justify-center" }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode("No Data Available.", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
      ])
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.pdfTimeoutError,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pdfTimeoutError) = $event)),
      timeout: 3000,
      color: "primary",
      location: "top"
    }, {
      default: _withCtx(() => [
        _cache[39] || (_cache[39] = _createElementVNode("h3", null, "Error downloading requested pdf. Please try again.", -1)),
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          class: "d-flex ml-auto",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.pdfTimeoutError = false))
        }, {
          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}